import { render, staticRenderFns } from "./SignInMenu.vue?vue&type=template&id=08b49e4c&"
import script from "./SignInMenu.vue?vue&type=script&lang=js&"
export * from "./SignInMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports